module.exports = __webpack_public_path__ + "static/media/45-iveco.07fe97b1.jpg";